import { MissionTypeInput } from '../../lib/types/models/mission-type/mission-type-input'
import { UpdateInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function updateMissionType({ id, ...data }: UpdateInput<MissionTypeInput>) {
  return restApiClient.url(constructApiUrl(API.missionTypes.update.url, { id })).patch(data)
}
